import TeaButtonGroup from "../../../../src/components/TeaButtonGroup";
import * as React from 'react';
export default {
  TeaButtonGroup,
  React
};